import { FC } from 'react'

import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductInfoModal } from 'featureSliced/widgets/Modals/ProductInfoModal'

type ProductInfoInlineProps = {
  product: IProduct
}

/**
 * QRM-641 (team decision): on the web layout the product modal has room for the
 * ingredients and nutrition table itself, so the "i" button and its second sheet
 * are dropped and the same body renders inline. The phone layout keeps the button
 * (see ProductInfoButton) — there is no room for this there.
 *
 * The weight disclaimer is suppressed because UnitSellCodePrice already prints it
 * directly under the price.
 */
export const ProductInfoInline: FC<ProductInfoInlineProps> = ({ product }) => {
  if (!product.hasProductInfo) return null

  return (
    <ProductInfoModal
      categoryId={product.categoryId}
      productId={product.id}
      unitSellCode={product.unitSellCode}
      withWeightDisclaimer={false}
    />
  )
}
